import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 空白模版
// const blank = {template: '<router-view></router-view>'}
const router = new Router({
  routes: [
    {
      path: '*',
      name: '404',
      component: () => import('@/components/pages/404.vue')
    },
    {
      path: '/couponCenter/home',
      name: 'couponCenterhome',
      component: () => import('@/components/pages/couponCenter/home.vue')
    },
    {
      path: '/couponCenter/orderCenter',
      name: 'couponCenterorderCenter',
      component: () => import('@/components/pages/couponCenter/orderCenter.vue')
    },
    {
      path: '/couponCenter/success',
      name: 'couponCentersuccess',
      component: () => import('@/components/pages/couponCenter/successPage.vue')
    },
    {
      path: '/couponCenter/couponPage',
      name: 'couponCentercouponPage',
      component: () => import('@/components/pages/couponCenter/couponPage.vue')
    },
    {
      path: '/feeRecharge/home',
      name: 'feeRechargehome',
      component: () => import('@/components/pages/feeRecharge/home.vue')
    },
    {
      path: '/feeRecharge/homeNew',
      name: 'feeRechargehomeNew',
      component: () => import('@/components/pages/feeRecharge/homeNew.vue')
    },
    {
      path: '/feeRecharge/record',
      name: 'feeRechargerecord',
      component: () => import('@/components/pages/feeRecharge/record.vue')
    },
    {
      path: '/packageRecharge/home',
      name: 'packageRechargehome',
      component: () => import('@/components/pages/packageRecharge/home.vue')
    },
    // {
    //   path: '/packageRecharge/record',
    //   name: 'packageRechargerecord',
    //   component: () => import('@/components/pages/packageRecharge/record.vue')
    // }
  ]
})

router.afterEach((to, from) => {
  if(to.name.indexOf('couponCenter')===0){
    window._paq.push(['setCustomUrl', '0.01元购权益卡-'+to.name])
    window._paq.push(['trackPageView']);
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js